
module ProcessEditor {
    export function serviceBusTriggerDirective(): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "serviceBusTriggerEditor.htm",
            controller: "ServiceBusTriggerController",
            controllerAs: "ctrl",
            bindToController: true,
            scope: {
                config: "="
            }
        }
    }
    app.directive("frendsServiceBusTrigger", [serviceBusTriggerDirective]);
    
    export interface IServiceBusTrigger {
        queueName: string ;
        connectionString: string;
        maxConcurrentMessages: number;
        consumeMessageImmediately: boolean;
        reply: boolean;
        replyErrors: boolean;
        replyTo: string;
    }

    export class ServiceBusTriggerController {
        public config: IServiceBusTrigger;

        constructor() {
            if (this.config.queueName == null) {
                this.config = {
                    queueName: "",
                    connectionString: "",
                    maxConcurrentMessages: 10,
                    consumeMessageImmediately: true,
                    reply: false,
                    replyErrors: false,
                    replyTo: ""
                }
            }
            if (this.config.consumeMessageImmediately === undefined) {
                this.config.consumeMessageImmediately = false; // migrate old 4.1 alpha values as false (same functionality)
                this.config.maxConcurrentMessages = 10;
            }
        }
    }
    app.controller("ServiceBusTriggerController", [ServiceBusTriggerController]);
}